import { createContext } from "react";

export const MenuContext = createContext(false);

export const DataContext = createContext([]);
